import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

export interface PracticeLockSetting {
  manualPracticeLocked: boolean;
}

interface UpdatePracticeLockConfig
  extends AxiosRequestConfig<PracticeLockSetting> {
  baseURL: string;
  body: PracticeLockSetting;
  data: PracticeLockSetting;
  method: 'PATCH';
  url: `/teachers/${string}/classes/${string}/practice-lock`;
}

/**
 * PATCH /vo/v1/teachers/{teacherId}/classes/{classId}/practice-lock
 */
export const updatePracticeLock = (
  teacherId: string,
  classId: string,
  data: PracticeLockSetting,
): UpdatePracticeLockConfig => {
  return {
    baseURL: BASE_API,
    body: data,
    data,
    method: 'PATCH',
    url: `/teachers/${teacherId}/classes/${classId}/practice-lock`,
  } as const;
};
